import { findNode } from './findNode.mjs';

/**
 * Iterate through all of the nodes in the editor and break early for the first truthy match. Otherwise
 * returns false.
 */
const someNode = (editor, options) => {
  return Boolean(findNode(editor, options));
};

export { someNode };
